import { useState, useEffect, useRef } from "react";

import Modal from "react-bootstrap/Modal";

import { api, cleanAIAnswer, parseArray, robustJsonParse, speakGerman } from "../pureFunctions";
import { Button, Form, Col, Alert, Row, Spinner, Table, ButtonGroup } from "react-bootstrap";
import { header } from "../globalVariables";

import aiIcon from "../img/ki.png";
import editIcon from "../img/edit.png";

import { milieuForm, milieuOutputConfig, milieuPrompt, milieuTexte } from "./MilieuData";
import TextMitZeilennummern from "../Zeilennummern";
import NummerierteSaetze from "../NummerierteSaetze";
import { formatText } from "../formatFunctions";
import { useContextMenu, ContextMenu, getItemsForContext } from "../Utils/ContextMenu";
import MyProgressBar from "../Tools/MyProgressBar";
import { SpinnerGroup } from "../Utils/SpinnerGroup";
import { debouncedSaveEstateData, saveEstateData } from "../networkFunctions";
import LoadingAnimation from "../LoadingAnimation";

export default function AIExpoCheck({selectedModel, getCleanData, aiLoading, setAiLoading, user }) {
   const [checkedData, setCheckedData] = useState("");

   async function checkData() {
      setAiLoading((prev) => ({ ...prev, dataCheck: "loading" }));
      const cleanData = getCleanData();
      const dataCheckPrompt = `Überprüfe die Daten, ob sich hier in den Daten irgendwelche Felder wiedersprechen: 
      $DATEN
      
      WICHTIG
      Gebe wirklich nur Punkte zurück, die sich signifikant wiedersprechen, ignoriere Kleinigkeiten. Halte dich kurz.
      Erfinde keine neuen Fakten. 

      FORMATIERUNG
      Antworte in kurzen präzisen Stichpunkten.
      Nutze ggf. **Doppelsternchen** oder __Doppelunterstriche__ um Aspekte hervorzuheben. Nutze aber niemals beides zusammen.
      `;
      let finalPrompt = dataCheckPrompt.replace("$DATEN", JSON.stringify({ objektDaten: cleanData }, null, 2));

      console.log(finalPrompt);

      const content = await api
         .post(
            `api/ai_prompt`,
            {
               model: selectedModel,
               messages: [
                  { role: "system", content: finalPrompt },
                  { role: "user", content: "Führe den systemprompt aus" },
               ],
            },
            header,
         )
         .then((data) => {
            console.log(data);
            console.log(data?.data?.content);

            return data?.data?.content ?? data?.content;
            // return robustJsonParse(data?.data?.content ?? data?.content);
         })
         .catch((err) => {
            console.log(err);
            console.log(err.error);
            setAiLoading((prev) => ({ ...prev, dataCheck: "error" }));
         });

      console.log(content);
      setCheckedData(content);
      setAiLoading((prev) => ({ ...prev, dataCheck: false }));
   }

   return (
      <>
         <div>
            <Button
               className="my-2 w-100"
               style={{ background: "#047" }}
               onClick={() => {
                  checkData();
               }}
            >
               {aiLoading?.dataCheck === "loading" ? (
                  <LoadingAnimation />
               ) : (
                  <span>Daten auf Unstimmigkeiten überprüfen</span>
               )}
            </Button>

            {checkedData && (
               <Alert className="my-2 p-4">
                  <h3>Noch experimentell und ohne Gewähr...:</h3>
                  <Alert
                     style={{
                        whiteSpace: "pre-line",
                     }}
                  >
                     {formatText(checkedData)}
                  </Alert>
               </Alert>
            )}
         </div>
      </>
   );
}
